/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authKayitOlRouteImport } from './routes/(auth)/kayit-ol'
import { Route as authGirisYapRouteImport } from './routes/(auth)/giris-yap'
import { Route as AuthenticatedEgitmenlerIndexRouteImport } from './routes/_authenticated/egitmenler/index'
import { Route as AuthenticatedBolumlerIndexRouteImport } from './routes/_authenticated/bolumler/index'
import { Route as AuthenticatedBolumlerBolumDetayBolumIdIndexRouteImport } from './routes/_authenticated/bolumler/bolumDetay/$bolumId/index'
import { Route as AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRouteImport } from './routes/_authenticated/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
import { Route as AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRouteImport } from './routes/_authenticated/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'

const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authSignIn2LazyRouteImport = createFileRoute('/(auth)/sign-in-2')()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedUsersIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/',
)()
const AuthenticatedTasksIndexLazyRouteImport = createFileRoute(
  '/_authenticated/tasks/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedSettingsNotificationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsDisplayLazyRouteImport = createFileRoute(
  '/_authenticated/settings/display',
)()
const AuthenticatedSettingsAppearanceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/appearance',
)()
const AuthenticatedSettingsAccountLazyRouteImport = createFileRoute(
  '/_authenticated/settings/account',
)()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authSignIn2LazyRoute = authSignIn2LazyRouteImport
  .update({
    id: '/(auth)/sign-in-2',
    path: '/sign-in-2',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-in-2.lazy').then((d) => d.Route))
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authKayitOlRoute = authKayitOlRouteImport.update({
  id: '/(auth)/kayit-ol',
  path: '/kayit-ol',
  getParentRoute: () => rootRouteImport,
} as any)
const authGirisYapRoute = authGirisYapRouteImport.update({
  id: '/(auth)/giris-yap',
  path: '/giris-yap',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexLazyRoute =
  AuthenticatedUsersIndexLazyRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTasksIndexLazyRoute =
  AuthenticatedTasksIndexLazyRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tasks/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedEgitmenlerIndexRoute =
  AuthenticatedEgitmenlerIndexRouteImport.update({
    id: '/egitmenler/',
    path: '/egitmenler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBolumlerIndexRoute =
  AuthenticatedBolumlerIndexRouteImport.update({
    id: '/bolumler/',
    path: '/bolumler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/display.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAppearanceLazyRoute =
  AuthenticatedSettingsAppearanceLazyRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/appearance.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBolumlerBolumDetayBolumIdIndexRoute =
  AuthenticatedBolumlerBolumDetayBolumIdIndexRouteImport.update({
    id: '/bolumler/bolumDetay/$bolumId/',
    path: '/bolumler/bolumDetay/$bolumId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute =
  AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRouteImport.update({
    id: '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId',
    path: '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute =
  AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRouteImport.update({
    id: '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId',
    path: '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/giris-yap': typeof authGirisYapRoute
  '/kayit-ol': typeof authKayitOlRoute
  '/otp': typeof authOtpRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/bolumler': typeof AuthenticatedBolumlerIndexRoute
  '/egitmenler': typeof AuthenticatedEgitmenlerIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
  '/bolumler/bolumDetay/$bolumId': typeof AuthenticatedBolumlerBolumDetayBolumIdIndexRoute
  '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute
  '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute
}
export interface FileRoutesByTo {
  '/giris-yap': typeof authGirisYapRoute
  '/kayit-ol': typeof authKayitOlRoute
  '/otp': typeof authOtpRoute
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/bolumler': typeof AuthenticatedBolumlerIndexRoute
  '/egitmenler': typeof AuthenticatedEgitmenlerIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
  '/bolumler/bolumDetay/$bolumId': typeof AuthenticatedBolumlerBolumDetayBolumIdIndexRoute
  '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute
  '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/(auth)/giris-yap': typeof authGirisYapRoute
  '/(auth)/kayit-ol': typeof authKayitOlRoute
  '/(auth)/otp': typeof authOtpRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(auth)/sign-in-2': typeof authSignIn2LazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/_authenticated/bolumler/': typeof AuthenticatedBolumlerIndexRoute
  '/_authenticated/egitmenler/': typeof AuthenticatedEgitmenlerIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexLazyRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexLazyRoute
  '/_authenticated/bolumler/bolumDetay/$bolumId/': typeof AuthenticatedBolumlerBolumDetayBolumIdIndexRoute
  '/_authenticated/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute
  '/_authenticated/bolumler/bolumDetay/$bolumId/sinavlar/$dersId': typeof AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/giris-yap'
    | '/kayit-ol'
    | '/otp'
    | '/settings'
    | '/sign-in-2'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/bolumler'
    | '/egitmenler'
    | '/help-center'
    | '/settings/'
    | '/tasks'
    | '/users'
    | '/bolumler/bolumDetay/$bolumId'
    | '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
    | '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/giris-yap'
    | '/kayit-ol'
    | '/otp'
    | '/sign-in-2'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/bolumler'
    | '/egitmenler'
    | '/help-center'
    | '/settings'
    | '/tasks'
    | '/users'
    | '/bolumler/bolumDetay/$bolumId'
    | '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
    | '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/(auth)/giris-yap'
    | '/(auth)/kayit-ol'
    | '/(auth)/otp'
    | '/_authenticated/settings'
    | '/(auth)/sign-in-2'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/bolumler/'
    | '/_authenticated/egitmenler/'
    | '/_authenticated/help-center/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
    | '/_authenticated/bolumler/bolumDetay/$bolumId/'
    | '/_authenticated/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
    | '/_authenticated/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authGirisYapRoute: typeof authGirisYapRoute
  authKayitOlRoute: typeof authKayitOlRoute
  authOtpRoute: typeof authOtpRoute
  authSignIn2LazyRoute: typeof authSignIn2LazyRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/kayit-ol': {
      id: '/(auth)/kayit-ol'
      path: '/kayit-ol'
      fullPath: '/kayit-ol'
      preLoaderRoute: typeof authKayitOlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/giris-yap': {
      id: '/(auth)/giris-yap'
      path: '/giris-yap'
      fullPath: '/giris-yap'
      preLoaderRoute: typeof authGirisYapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/egitmenler/': {
      id: '/_authenticated/egitmenler/'
      path: '/egitmenler'
      fullPath: '/egitmenler'
      preLoaderRoute: typeof AuthenticatedEgitmenlerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bolumler/': {
      id: '/_authenticated/bolumler/'
      path: '/bolumler'
      fullPath: '/bolumler'
      preLoaderRoute: typeof AuthenticatedBolumlerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/bolumler/bolumDetay/$bolumId/': {
      id: '/_authenticated/bolumler/bolumDetay/$bolumId/'
      path: '/bolumler/bolumDetay/$bolumId'
      fullPath: '/bolumler/bolumDetay/$bolumId'
      preLoaderRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bolumler/bolumDetay/$bolumId/sinavlar/$dersId': {
      id: '/_authenticated/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
      path: '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
      fullPath: '/bolumler/bolumDetay/$bolumId/sinavlar/$dersId'
      preLoaderRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId': {
      id: '/_authenticated/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
      path: '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
      fullPath: '/bolumler/bolumDetay/$bolumId/dersNotlari/$dersId'
      preLoaderRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute
  AuthenticatedSettingsAppearanceLazyRoute: typeof AuthenticatedSettingsAppearanceLazyRoute
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsAppearanceLazyRoute:
      AuthenticatedSettingsAppearanceLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBolumlerIndexRoute: typeof AuthenticatedBolumlerIndexRoute
  AuthenticatedEgitmenlerIndexRoute: typeof AuthenticatedEgitmenlerIndexRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedTasksIndexLazyRoute: typeof AuthenticatedTasksIndexLazyRoute
  AuthenticatedUsersIndexLazyRoute: typeof AuthenticatedUsersIndexLazyRoute
  AuthenticatedBolumlerBolumDetayBolumIdIndexRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdIndexRoute
  AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute
  AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute: typeof AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBolumlerIndexRoute: AuthenticatedBolumlerIndexRoute,
  AuthenticatedEgitmenlerIndexRoute: AuthenticatedEgitmenlerIndexRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedTasksIndexLazyRoute: AuthenticatedTasksIndexLazyRoute,
  AuthenticatedUsersIndexLazyRoute: AuthenticatedUsersIndexLazyRoute,
  AuthenticatedBolumlerBolumDetayBolumIdIndexRoute:
    AuthenticatedBolumlerBolumDetayBolumIdIndexRoute,
  AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute:
    AuthenticatedBolumlerBolumDetayBolumIdDersNotlariDersIdRoute,
  AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute:
    AuthenticatedBolumlerBolumDetayBolumIdSinavlarDersIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authGirisYapRoute: authGirisYapRoute,
  authKayitOlRoute: authKayitOlRoute,
  authOtpRoute: authOtpRoute,
  authSignIn2LazyRoute: authSignIn2LazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
